import { __rest, __assign } from '../../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import { Root as Root$1 } from './Root.styles.js';

var Root = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var collapsibleProp = props.type === "single" && props.collapsible === undefined
        ? {
            collapsible: true,
        }
        : undefined;
    return (React.createElement(Root$1, __assign({ "data-testid": "AccordionWrapper" }, props, collapsibleProp), children));
};

export { Root as default };
//# sourceMappingURL=Root.js.map
